export const DebugInfoNalog = () => {
  return (
    <div className="debug-info-om">
      <div>
        <p>Nalog Client ID: <strong>{process.env.REACT_APP_TNACCOUNT_CLIENT_ID}</strong></p>
        <p>Nalog Domain: <strong>{process.env.REACT_APP_TNACCOUNT_DOMAIN}</strong></p>
      </div>
    </div>
  );
};
